import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';



import {Siteconfig} from "./siteconfig.page";

export const routes: Routes = [
    { path: 'siteconfig', component: Siteconfig },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Siteconfig
    ]
})

export class SiteconfigModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/siteconfig/siteconfig.module.ts